import { FC } from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Document } from '@contentful/rich-text-types';
import { CONTENTFUL_RICH_TEXT_OPTIONS } from '@zoopla/cms/contentful-render-options';
import { Box } from '@zoopla-eng/zds-components/box';
import {
    faqContainer,
    answerStyles,
    authorThumbnail,
    answerContainer,
    authorCaption,
} from './ExpandedFaqCollection.styles.css';
import { CmsImage } from '@zoopla/cms/image';
import { Link } from '@zoopla-eng/zds-components/link';
import { fontGroups } from '@zoopla-eng/zds-components/themes/font-groups';
import { CmsFaqSchema } from '@zoopla/cms/faq-schema';
import type { FaqCollection } from '@zoopla/cms/types';

export const ExpandedFaqCollection: FC<FaqCollection> = ({
    title,
    description,
    faqs,
}) => {
    return (
        <>
            <CmsFaqSchema faqs={faqs} />

            <Box display="flex" flexDirection="column" rowGap="M200">
                <Box display="flex" flexDirection="column" rowGap="S300">
                    {title ? (
                        <h2 className={`${fontGroups.kettle}`}>{title}</h2>
                    ) : null}

                    {description && description !== '' ? (
                        <p className={`${fontGroups.ladle}`}>{description}</p>
                    ) : null}
                </Box>

                {faqs.length > 0 && (
                    <div className={faqContainer}>
                        {faqs?.map(({ question, answer, author }, index) => (
                            <figure
                                className={answerContainer}
                                key={`faq-${index}`}
                            >
                                <blockquote className={answerStyles}>
                                    <h3 className={`${fontGroups.plate}`}>
                                        {question}
                                    </h3>
                                    {documentToReactComponents(
                                        answer as Document,
                                        CONTENTFUL_RICH_TEXT_OPTIONS
                                    )}
                                </blockquote>

                                {author ? (
                                    <figcaption className={authorCaption}>
                                        <CmsImage
                                            src={author?.authorImage.url || ''}
                                            alt=""
                                            width={160}
                                            imgClassName={authorThumbnail}
                                            focus="face"
                                            fit="thumb"
                                            sizes="80px"
                                        />
                                        <div>
                                            <h4>{author.authorName}</h4>
                                            {author?.authorSlug &&
                                            author?.jobTitle ? (
                                                <Link
                                                    href={`/discover/meet-the-team/${author.authorSlug}/`}
                                                >
                                                    {author.jobTitle}
                                                </Link>
                                            ) : null}
                                        </div>
                                    </figcaption>
                                ) : null}
                            </figure>
                        ))}
                    </div>
                )}
            </Box>
        </>
    );
};

export default ExpandedFaqCollection;
